import { useGlobal } from '@/utils/useGlobal';
import { EFFixedWinClose } from '@/components/UI/svg/mm100';
import AppModal from './AppModal';
import PowerHub from './PowerHub';
import CablePack from './CablePack';
import LFPBatteries from './LFPBatteries';
import SolarPanels from './SolarPanels';
import ListD1Modal from './ListD1Modal';
import ListD2Modal from './ListD2Modal';
import css from './index.module.scss';

export default function ModalsH5({ active, callBack }: any) {
    const { useEffect } = useGlobal();

    useEffect(() => {
        if (active && window) {
            const scrollTo = document.querySelector(`.modalsH5 .${active}`) as HTMLElement;
            const scrollElem = document.querySelector('.modalsH5 .modals-body') as HTMLElement;
            scrollElem.scrollTo({ top: scrollTo?.offsetTop - 50 || 0 });
        }
    }, [active]);

    return (
        <div className={`modalsH5 ${css.modalsH5}`}>
            <div className="close-bar">
                <div className="closeBtn" onClick={() => callBack('')}>
                    <EFFixedWinClose />
                </div>
            </div>
            <div className="modals-body">
                <AppModal />
                <PowerHub />
                <CablePack />
                <LFPBatteries />
                <SolarPanels />
                <ListD1Modal />
                <ListD2Modal />
            </div>
        </div>
    );
}
